{
  "articles": {
    "agents": {"question": "Welche Agenten kann ich nutzen, und wie installiere ich einen?"},
    "executableItems": {"question": "Welche Elemente zählen als Werkzeuge?"},
    "githubConnection": {"question": "Was bewirkt eine Verbindung?"},
    "importCorpus": {"question": "Wie läuft ein Import?"},
    "localImport": {"question": "Wie muss der Ordner aussehen?"},
    "privateRepository": {"question": "Wie importiere ich ein privates Repository?"}
  },
  "breadcrumbs": "Sie sind hier",
  "build": "DMW {{commit}} · {{started}}",
  "close": "Hilfe schließen",
  "glossary": "Glossar",
  "groups": {
    "dataModel": "Datenmodell",
    "documents": "Dokumente",
    "reference": "Nachschlagen",
    "settings": "Einstellungen und Verwaltung",
    "start": "Erste Schritte",
    "work": "Arbeiten in DMW"
  },
  "guide": "Anleitung",
  "next": "Weiter",
  "notFound": {
    "start": "Zum Anfang der Hilfe.",
    "text": "Der Link ist vielleicht veraltet.",
    "title": "Diese Hilfeseite gibt es nicht"
  },
  "onThisPage": "Auf dieser Seite",
  "open": "Hilfe",
  "pager": "Vorherige und nächste Seite",
  "previous": "Zurück",
  "search": {
    "label": "Hilfe durchsuchen",
    "none": "Nichts gefunden für „{{query}}“.",
    "placeholder": "Hilfe durchsuchen (/)",
    "results": "Treffer"
  },
  "skipToContent": "Zum Inhalt springen",
  "thisPage": "Hilfe zu dieser Seite",
  "title": "Hilfe",
  "topics": "Themen"
}
